export default "The all-new <a href=\"/shop\">Merch Shop</a> is here. Check it out now!";